export const cmykToRGB = (c: number, m: number, y: number, k: number, a: number) => {
    c = c / 100;
    m = m / 100;
    y = y / 100;
    k = k / 100;
    return {
        r: 255 * (1 - c) * (1 - k),
        g: 255 * (1 - m) * (1 - k),
        b: 255 * (1 - y) * (1 - k),
        a,
    };
};
